import { render } from "./FooterBar.vue?vue&type=template&id=fa734380&scoped=true"
import script from "./FooterBar.vue?vue&type=script&lang=js"
export * from "./FooterBar.vue?vue&type=script&lang=js"

import "./FooterBar.vue?vue&type=style&index=0&id=fa734380&lang=css"
import "./FooterBar.vue?vue&type=style&index=1&id=fa734380&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fa734380"]])

export default __exports__